import { useParams, useSearchParams } from 'src/routes/hooks';
import PublicCandidateProfile from 'src/sections/public-candidate-profile';

export default function PublicCandidateProfilePage() {
  // hooks
  const { candidateId } = useParams();
  const searchParams = useSearchParams();
  const token = searchParams.get('token');

  return (
    <PublicCandidateProfile
      candidateType="PUBLIC_CANDIDATE"
      layout="full"
      candidateId={candidateId}
      token={token}
    />
  );
}
